import React, { useState } from 'react';
import { toast } from 'sonner';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { LANGUAGES } from '@/components/login/loginHelpers';

export default function LanguageSelector() {
  const [language, setLanguage] = useState(() => localStorage.getItem('safer_language') || 'en');
  const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  const choose = (lang) => {
    setLanguage(lang.code);
    localStorage.setItem('safer_language', lang.code);
    toast.success(`Language changed to ${lang.name}`);
  };

  return (
    <div className="absolute top-4 right-4" data-testid="language-selector">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2" data-testid="language-selector-trigger">
            <Globe className="h-4 w-4" />
            <span>{current.flag}</span>
            <span className="hidden sm:inline">{current.name}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {LANGUAGES.map((lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => choose(lang)}
              className={language === lang.code ? 'bg-accent' : ''}
              data-testid={`language-option-${lang.code}`}
            >
              <span className="mr-2">{lang.flag}</span>
              {lang.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
